import script from "./IndexCourseUsersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexCourseUsersView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__